import React from 'react';
import { GoogleMaps, Alert, AppLocaleProvider } from 'sd-ui-components';
import { compose, withProps } from 'recompose';
import { observer, inject } from 'mobx-react';
const { FormattedMessage } = AppLocaleProvider;
const { withScriptjs, withGoogleMap, GoogleMap, Marker } = GoogleMaps;
@inject('ConfigStore')
@observer
class EventMap extends React.Component {
  render() {
    const hasMap = !(isNaN(this.props.latitude) || isNaN(this.props.longitude));
    const LocateNowMap = compose(
      withProps({
        googleMapURL:
          this.props.ConfigStore.config.googleMapsUrl +
          this.props.ConfigStore.config.googleMapsKey,
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />
      }),
      withScriptjs,
      withGoogleMap
    )(props => (
      <GoogleMap
        defaultZoom={8}
        defaultCenter={{ lat: this.props.latitude, lng: this.props.longitude }}
        defaultOptions={{ tilt: 0, rotateControl: false }}
      >
        {
          <div>
            <Marker
              position={{ lat: this.props.latitude, lng: this.props.longitude }}
              label={{
                text: this.props.safetyScore,
                fontSize: '10px',
                color: 'white'
              }}
              // icon={props.icon}
            />
          </div>
        }
      </GoogleMap>
    ));

    return (
      <div>
        {hasMap && <LocateNowMap />}
        {!hasMap && (
          <Alert
            className="safety-notifications"
            type={'error'}
            message={
              <FormattedMessage
                id="App.EventDetails.Errors.MapUnavailable"
                defaultMessage="Event does not have GPS information."
              />
            }
            showIcon
          />
        )}
      </div>
    );
  }
}
export default EventMap;



// WEBPACK FOOTER //
// ./src/containers/EventDetails/EventMap.jsx